var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgRightIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "12px",
    viewBox: "0 0 16 12",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "2E649974-1824-49CE-921E-633BDAD1C494@3x") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "KP_Contribution_Step-1_Designate-ONE-Sector_Selected",
    transform: "translate(-186.000000, -1374.000000)",
    fill: "#3FAD93",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-20-Copy-8",
    transform: "translate(79.000000, 1361.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M121.150397,13.3206646 L112.506885,22.0523866 L108.808289,18.9401389 C108.345614,18.5490272 107.652312,18.6025223 107.2612,19.0644901 C106.870088,19.5271658 106.923583,20.2204678 107.385551,20.6115795 L111.849759,24.3816674 C112.063028,24.5595101 112.312435,24.6303627 112.56113,24.6303627 C112.845963,24.6303627 113.130085,24.5233796 113.343354,24.3101035 L122.680097,14.8662993 C123.106634,14.4397613 123.106634,13.7457478 122.680097,13.3192098 C122.270916,12.8933654 121.57692,12.8933654 121.150365,13.3205992 L121.150397,13.3206646 Z",
    id: "Path-Copy"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightIcon);
export default __webpack_public_path__ + "static/media/right-icon.f724d87c1b9e1aca9a87dc94dce641e3.svg";
export { ForwardRef as ReactComponent };